import axios, { AxiosError } from "axios";
import env from "../environment_system/env_system";
import { clearLogout, getAuthData, getAuthSessionData } from "utils/auth/authUtils";
import { checkValidObject } from "GenericForms/Helper";
export const BaseURL = env.base_url;
export const MediaBaseURL = env.media_base_url ?? "";
let refreshToken: string | null = null;

const apiGlobal = axios.create({
  baseURL: `${BaseURL}`,
  headers: {
    "Content-type": "application/json",
    Authorization: `Bearer ${getAuthData("access")}`,
  },
  //withCredentials: true
});

export const apiMedia = axios.create({
  baseURL: `${BaseURL}`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${getAuthData("access")}`,
  },
});

apiGlobal.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const refresh = getAuthData("refresh");
    if ((error.response?.status === 401 || error.response?.status === 403) && refresh) {
      await axios.post(`${BaseURL}/token-refresh/`, { refresh }).then(async (res: any) => {
        const data: any = localStorage.getItem("authData");
        const JSONData = JSON.parse(data);
        if (checkValidObject(JSONData)) {
          JSONData.access = res.data.access;
          JSONData.refresh = res.data.refresh;
          // eslint-disable-next-line no-restricted-syntax
          localStorage.setItem('authData', JSON.stringify(JSONData));
          // eslint-disable-next-line no-restricted-syntax
          sessionStorage.setItem('authData', JSON.stringify(JSONData));
          window.location.reload();
        }
        // sessionStorage.setItem("authData", sessionStorageData);
      }).catch((err: any) => {
        console.error(err);
        clearLogout();
        window.location.href = "/login";
      })
    }
    return Promise.reject(error);
  }
);

apiMedia.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const refresh = getAuthData("refresh");
    if ((error.response?.status === 401 || error.response?.status === 403) && refresh) {
      try {
        const res = await axios.post(`${MediaBaseURL}/token-refresh/`, { refreshToken });
        const localStorageData = getAuthData("authData");
        const sessionStorageData = getAuthSessionData("authData");
        localStorageData.access = res.data.access;
        localStorageData.refresh = res.data.refresh;
        sessionStorageData.access = res.data.access;
        sessionStorageData.refresh = res.data.refresh;
        localStorage.setItem("authData", localStorageData);
        sessionStorage.setItem("authData", sessionStorageData);
        if (error.config) {
          error.config.headers.Authorization = `Bearer ${res.data.access}`;
          return apiMedia(error.config);
        }
      } catch (err: any) {
        console.error(err);
        clearLogout();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const handleApiError = (error: AxiosError) => {
  try {
    console.error("API Request failed:", error.message);
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      if (status === 404) {
        console.error("Resource not found");
      } else if (status === 500) {
        console.error("Internal server error");
      } else if (status === 400) {
        console.error("Bad request");
      }
    }
  } catch (error) {
    console.error(error);
  }
};

export default apiGlobal;
